module.exports = __webpack_public_path__ + "img/Anna-Hourdaki.a566abc7.jpg";